/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { ClassificationNodeType } from '../../types';
import { getClassificationDataService } from 'src/services/azure-devops-api/get-classification-data-service';

export function useIterationAndAreaPathField() {
	const getIterationAndAreaPathOptions = useCallback(async (args: {
    organizationName: string;
    projectId: string;
    workItemField: string;
  }): Promise<Array<{ value: any; label: string }>> => {

		const otpListHandler = (
			classificationNode: ClassificationNodeType,
			options?: { customPushToResultList?: (item: ClassificationNodeType) => { value: string; label: string }}
		) => {
			const resultOpts: Array<{ value: any; label: string }> = [];
			const recursiveChecking = (arr: Array<ClassificationNodeType>) => {
				for (const item of arr) {
					if (options?.customPushToResultList) {
						resultOpts.push(options.customPushToResultList(item));
					}
  
					if (!options?.customPushToResultList) {
						resultOpts.push({
							value: item.path,
							label: item.path
						});
					}
  
					if (item.hasChildren && item.children) {
						recursiveChecking(item.children);
					}
				}
			};
  
			recursiveChecking([classificationNode]);
			return resultOpts.sort((a, b) => a.label.localeCompare(b.label));
		};
  
		const methods = {
			'System.AreaPath': (list: Array<ClassificationNodeType>) => {
				const classificationNode = list.find((item) => item.structureType === 'area') as ClassificationNodeType;
				const results = otpListHandler(classificationNode, {
					customPushToResultList(item) {
						let parsedPath = item.path;
						const isRoot = /Area$/gm.test(item.path);
            
						if (isRoot) {
							parsedPath = parsedPath.replace(/Area$/gm, '');
							parsedPath = parsedPath.replace(/\\$/, '');
						}

						parsedPath = parsedPath.replace('Area\\', '');
						parsedPath = parsedPath.replace(/^\\/, '');

						return {
							label: parsedPath,
							value: parsedPath
						};
					}
				});
				return results;
			},
			'System.IterationPath': (list: Array<ClassificationNodeType>) => {
				const classificationNode = list.find((item) => item.structureType === 'iteration') as ClassificationNodeType;
				const results = otpListHandler(classificationNode, {
					customPushToResultList(item) {
						let parsedPath = item.path;
						const isRoot = /Iteration$/gm.test(item.path);
            
						if (isRoot) {
							parsedPath = parsedPath.replace(/Iteration$/gm, '');
							parsedPath = parsedPath.replace(/\\$/, '');
						}

						parsedPath = parsedPath.replace('Iteration\\', '');
						parsedPath = parsedPath.replace(/^\\/, '');

						return {
							label: parsedPath,
							value: parsedPath
						};
					}
				});

				return results;
			}
		};
  
		const classificationList = await getClassificationDataService({
			organizationName:  args.organizationName,
			projectId: args.projectId,
		});

		switch (args.workItemField) {
		case 'System.AreaPath':
			return methods['System.AreaPath'](classificationList.value);
		case 'System.IterationPath':
			return methods['System.IterationPath'](classificationList.value);
		default:
			return [];
		}
	}, []);

	return {
		getIterationAndAreaPathOptions,
	};
}